module.exports = __webpack_public_path__ + "media/images/emblems/CH_Gibloux_COA-a8314ad18e7adf948bdd1b5ad4580c4a.svg";